 angular
  .module('vppApp')
  .service('BreakPointService', BreakPointService);

 BreakPointService.$inject = ['$window', '$rootScope', 'vppConfig', '$state'];

 function BreakPointService($window, $rootScope, vppConfig, $state) {
  function setVariables() {
    if ($window.innerWidth <= vppConfig.breakPoints.small) {
      $rootScope.small = true;
      $rootScope.medium = false;
      $rootScope.large = false;
    } else if ($window.innerWidth > vppConfig.breakPoints.small && $window.innerWidth <= vppConfig.breakPoints.medium) {
      $rootScope.small = false;
      $rootScope.medium = true;
      $rootScope.large = false;
    } else {
      $rootScope.small = false;
      $rootScope.medium = false;
      $rootScope.large = true;
    }
  }

  this.SetBreakPoint = function () {
    setVariables();

    angular.element($window).bind('resize', function () {
      setVariables();
    });

    angular.element($window).bind('orientationchange', function () {
      setVariables();
    });
  };
 }
